"use strict";
if (typeof window === 'object') {
    require('chart.js');
}
var core_1 = require('@angular/core');
var chart_component_1 = require('./chart.component');
var ɵngcc0 = require('@angular/core');
var ɵngcc1 = require('./chart.component');
var ChartModule = (function () {
    function ChartModule() {
    }
    ChartModule.ctorParameters = function () { return []; };
ChartModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ChartModule });
ChartModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ChartModule_Factory(t) { return new (t || ChartModule)(); } });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ChartModule, { declarations: [ɵngcc1.ChartComponent], exports: [ɵngcc1.ChartComponent] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ChartModule, [{
        type: core_1.NgModule,
        args: [{
                declarations: [chart_component_1.ChartComponent],
                exports: [chart_component_1.ChartComponent]
            }]
    }], function () { return []; }, null); })();
    return ChartModule;
}());
exports.ChartModule = ChartModule;

//# sourceMappingURL=chart.module.js.map